import lazyWithReload from '../../utils/lazyWithReload';
import createRecordDrawer from './createRecordDrawer';

const CrmLeadDrawer = lazyWithReload(() => import('./CrmLeadDrawer'), 'CrmLeadDrawer');

/**
 * URL-driven `?leadId=<short>`.
 * API: useCrmLeadDrawer() → { openLead, closeLead, version, bumpVersion, openLeadId, navInfo, navGo }
 * Trang danh sách lead gọi thêm useCrmLeadDrawerNav() để popup có nút trước/sau.
 */
const { Provider, useDrawer, useDrawerNav } = createRecordDrawer({
  param: 'leadId',
  kind: 'lead',
  Drawer: CrmLeadDrawer,
  names: { open: 'openLead', close: 'closeLead', openId: 'openLeadId' },
});

export const CrmLeadDrawerProvider = Provider;
export const useCrmLeadDrawer = useDrawer;
export const useCrmLeadDrawerNav = useDrawerNav;
